import { FILES_URL } from '../../../../configs/AppConfig';

const Overview = ({data}) => {

    const MyComponent=({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} className="my-component"/>
  );
}
console.log("overview data ", data.project)
  return (
    <div>
       <div className="proOverview proOverviewMrg flex flex-col">
            <div className="flex justify-between gap-[30px]">
        <div className="proOverviewChild">
        <h4 className="h4Create">Introduction : </h4>
                <MyComponent htmlContent={data.project?.project?.details?.introduction}/>
                </div>
       <div className="proOverviewChild">
          <h4 className="h4Create">NGSS Integration & Cross-Disciplinary Connections : </h4> 
              <MyComponent htmlContent={data.project?.project?.details?.ngssCross}/>
                 </div>
                  </div>
                          <div className="projectPic" style={{backgroundImage:`url(${FILES_URL}${data.project?.project?.coverImg?.url})`}}></div>
      </div>

    </div>
  );
};

export default Overview;
